import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { AppUser } from 'app/models/app-user';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Subject } from 'rxjs/Subject';
import { MatDialog, MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment.prod';


@Injectable()
export class UIService {
    private headers = new Headers();
    private pageTitleString;
    public forcePageName$ = new Subject<any>();
    private loaderState = new Subject<any>();
    loaderStateChange = this.loaderState.asObservable();
    private loaderMsg = new Subject<any>();
    loaderMsgChange = this.loaderMsg.asObservable();

    constructor(private dialog: MatDialog,
        private snack: MatSnackBar) {
    }


    // Data emitting function for displaying current page title in navigation bar
    public pageTitle = new Subject<any>();

    changeEmitted$ = this.pageTitle.asObservable();
    emitChange(myMessage: any) {
        // this.pageTitle.next(myMessage);
        this.pageTitleString = myMessage;
    }


    // Data emitting function for displaying current page title in navigation bar
    emitLoaderState(state: any, msg?: string) {
        if (msg) {
            this.loaderMsg.next(msg);
        }
        this.loaderState.next(state);
    }

    emitLoaderMessage(msg: string) {
        this.loaderMsg.next(msg);
    }
    getCurrentPage(): string {
        return this.pageTitleString;
    }
    closeAllDialogs() {
        this.dialog.closeAll();
    }

    updateLoaderMessage(msg) {
        this.emitLoaderMessage(msg);
    }

    startLoaderWithCustomMessage(msg: string) {
        this.loaderState.next(true);
    }

    endLoaderWithMessage(msg) {
        this.loaderMsg.next(msg);
        setTimeout(() => {
            this.emitLoaderState(false);
        }, 2500);
    }

    // alert a message box
    alertMessageBox(msg) {
        alert(msg);
        this.snack.open(msg, 'OK', {
            duration: 5000
        });
    }


    // Toggle navigation bar

    enableNavBar() {

    }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/UI/ui.service.ts